import { Button, Space } from 'antd';
import type { OrderType } from '../types';

interface Props {
  value: OrderType;
  onChange: (v: OrderType) => void;
}

const OPTIONS: { label: string; value: OrderType }[] = [
  { label: 'POS', value: 'POS' },
  { label: 'Online', value: 'ONLINE' },
  // [BỎ LIVESTREAM] ẩn khỏi UI chọn mới — comment out, KHÔNG xoá type
  // `OrderType`/dữ liệu cũ: `Orders/edit.tsx` vẫn cần đọc đúng giá trị
  // `LIVESTREAM` từ đơn đã tạo trước đây qua kênh Facebook/TikTok/Livestream.
  // { label: 'Livestream', value: 'LIVESTREAM' },
];

export function OrderTypeToggle({ value, onChange }: Props) {
  return (
    <Space.Compact block>
      {OPTIONS.map((opt) => (
        <Button
          key={opt.value}
          type={value === opt.value ? 'primary' : 'default'}
          onClick={() => onChange(opt.value)}
          size="small"
          style={{ flex: 1 }}
        >
          {opt.label}
        </Button>
      ))}
    </Space.Compact>
  );
}
